// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__-AmQW","LoginForm":"Login_LoginForm__tyWte","LoginFormInput":"Login_LoginFormInput__xRPgT","LoginFormTitle":"Login_LoginFormTitle__j4HpQ"};